import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

const transactionCommunication = (params) => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  return axiosGlobalInstance({
    method: 'POST',
    url: '/transaction.communication.php',
    data: params,
    headers: {
      token: decipher?.token?.value,
      action: 'transaction',
    }
  });
}

export default transactionCommunication;
